<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		icon?: string
		image?: string
		title?: string
		text?: string
		enableBackground?: boolean
		background?: string
		size?: string
		textSize?: string
		direction?: string
		textColor?: string
		iconColor?: string
	}>(),
	{
		icon: '',
		image: '',
		title: '',
		text: '',
		enableBackground: false,
		background: 'white',
		size: 'md',
		textSize: '',
		direction: 'row',
		textColor: 'text-black',
		iconColor: '',
	},
)

const itemClasses = computed(() => {
	const classes = []

	if (props.enableBackground) {
		classes.push(`bg-${props.background}`)
		classes.push('p-4')
		classes.push('rounded-md')
	}

	classes.push('flex')
	classes.push('items-center')
	classes.push('gap-2')

	if (props.direction === 'row') {
		classes.push('flex-row')
	} else if (props.direction === 'column') {
		classes.push('flex-col')
	}

	return classes
})

const iconClasses = computed(() => {
	const classes = []

	if (!!props.icon) {
		if (props.size === 'lg') {
			classes.push('h-12')
			classes.push('w-12')
		} else if (props.size === 'md') {
			classes.push('h-10')
			classes.push('w-10')
		} else if (props.size === 'sm') {
			classes.push('h-8')
			classes.push('w-8')
		} else if (props.size === 'xs') {
			classes.push('h-6')
			classes.push('w-6')
		}
	}

	if (!!props.image) {
		if (props.size === 'lg') {
			classes.push('h-20')
			classes.push('w-20')
		} else if (props.size === 'md') {
			classes.push('h-16')
			classes.push('w-16')
		} else if (props.size === 'sm') {
			classes.push('h-10')
			classes.push('w-10')
		} else if (props.size === 'xs') {
			classes.push('h-8')
			classes.push('w-8')
		}
	}

	classes.push(props.iconColor || props.textColor)

	return classes
})

const textClasses = computed(() => {
	const classes = []

	classes.push('flex-1')
	classes.push(props.textColor)

	if (!props.textSize) {
		if (props.size === 'lg') {
			classes.push('text-lg')
		} else if (props.size === 'md') {
			classes.push('text-base')
		} else if (props.size === 'sm') {
			classes.push('text-sm')
		}
	} else {
		if (props.textSize === 'lg') {
			classes.push('text-lg')
		} else if (props.textSize === 'md') {
			classes.push('text-base')
		} else if (props.textSize === 'sm') {
			classes.push('text-sm')
		}
	}

	if (props.direction === 'row') {
		classes.push('text-left')
	} else if (props.direction === 'column') {
		classes.push('text-center')
	}

	return classes
})
</script>

<template>
	<div :class="itemClasses">
		<Icon
			v-if="icon"
			:class="iconClasses"
			:name="props.icon"
		/>

		<img
			v-if="image"
			:class="iconClasses"
			:src="image"
		/>

		<div class="flex-1">
			<div v-if="title" :class="[textClasses, 'font-semibold']" v-html="title"></div>
			<div :class="[textClasses, 'font-normal']" v-html="text"></div>
		</div>
	</div>
</template>
